import type {DateObj} from './types';

import {allOf, not} from '../conditionalUtils';
import {
  DASH,
  dayValidator,
  DEFAULT_DATE_OBJ,
  monthValidator,
  SLASH,
  yearValidator,
} from './utils';

export const dateStringToDateObj = (dateString: string): DateObj => {
  try {
    // YYYY-MM-DD
    if (not(isValidInput(dateString))) {
      return DEFAULT_DATE_OBJ;
    }

    const match = (dateString.match(/\d+/g) || []).map(parseFloat);

    const [year, month, day] = match;

    return {
      _type: 'date',
      day: day!,
      month: month!,
      year: year!,
    };
  } catch (error) {
    return DEFAULT_DATE_OBJ;
  }
};

function isValidInput(dateString: string) {
  const isValidLen = dateString.length === 10;

  if (not(isValidLen)) {
    return false;
  }

  let separator = '';

  switch (true) {
    case dateString.includes(SLASH):
      separator = SLASH;
      break;
    case dateString.includes(DASH):
      separator = DASH;
      break;
    default:
      return false;
  }

  const entries = dateString.split(separator);
  const isValidEntriesLen = entries.length === 3;
  const isValidEntries = entries
    .map((value, index) => {
      switch (index) {
        case 0:
          return yearValidator(value);
        case 1:
          return monthValidator(value);
        case 2:
          return dayValidator(value);
        default:
          return false;
      }
    })
    .reduce((a, b) => a && b, true);

  return allOf([isValidLen, isValidEntriesLen, isValidEntries]);
}
